<template lang="html">
  <div class="question-container">
    <div class="close-icon-div">
      <v-btn flat icon @click = "$emit('close')"><i class="close-icon"></i></v-btn>
      <span class="question-number">{{ `${index+1} / ${totalNumberOfQuestion}` }}</span>
    </div>
    <div class="title--txt">
     <vue-markdown :source = "taskCompletionItem.task_completion_text">{{ taskCompletionItem.task_completion_text }}</vue-markdown>
    </div>
    <div class="welcome-txt">
      <v-container fluid class="pa-0">
        <v-layout row wrap class="input-container mb-24">
          <v-flex xs12 sm12 class="pa-0">
            <datetime
              v-model="completionValue"
            >
          </datetime>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <div class="button-container">
      <v-btn flat small class="edit" @click = "$emit('previous')"><span>Back</span></v-btn>
      <v-btn :disabled="!completionValue" large @click = "$emit('next'); submitTaskCompletionItemValue();" class="next-button">Next</v-btn>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { Datetime } from 'vue-datetime';
import VueMarkdown from 'vue-markdown';
import 'vue-datetime/dist/vue-datetime.css';

export default {
  props: {
    index: {
      type: Number,
    },
  },
  components: {
    Datetime,
    VueMarkdown,
  },
  data() {
    return {
      completionValue: null,
      totalNumberOfQuestion: null,
    };
  },
  computed: {
    taskCompletionItem() {
      const items = this.$store.getters['completionQuestions/taskCompletionList'];
      this.totalNumberOfQuestion = items.length;
      return items[this.index] || {};
    },
  },
  methods: {
    submitTaskCompletionItemValue() {
      const date = moment(this.completionValue).utc().format('YYYY-MM-DD hh:mm:ss');
      this.$store.dispatch('completionQuestions/submitTaskCompletionItem', {
        completion_date: date,
        task_completion_item_id: this.taskCompletionItem.task_completion_item_id,
      });
      this.defaultState();
    },
    defaultState() {
      this.completionValue = null;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/shared.scss";
@import "~styles/completion_questions.scss";
#app {
  input {
    width: 100%;
  }
  .button-container {
    flex-grow: 2;
  }

  .title--txt {
    flex-grow: 5;
  }
  .welcome-txt {
    flex-grow: 12;
  }

  @media only screen and (min-width:500px) {
    .button-container {
      text-align: center;
    }
  }

  @media only screen and (max-width:499px) {
    .question-number {
      margin-left: 33%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QuestionsTypes/DateQuestion.vue